/*
 * Ryan O'Dowd
 * 2025-12-19
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Database,
} from '@nozbe/watermelondb';
import Footnote from './models/Footnote';
import LokiJSAdapter from '@nozbe/watermelondb/adapters/lokijs';
import Translation from './models/Translation';
import VerseText from './models/VerseText';
import fb from '@utils/firebase';
import migrations from './migrations';
import schema from './schema';

const adapter = new LokiJSAdapter({
  schema,
  // (You might want to comment out migrations for development purposes -- see Migrations documentation)
  migrations,
  useWebWorker: false,
  useIncrementalIndexedDB: true,
  // dbName: 'myapp', // optional db name

  // --- Optional, but recommended event handlers:
  // @TODO: implement

  onQuotaExceededError: (error) => {
    // Browser ran out of disk space -- offer the user to reload the app or log out
    fb.recordError(fb.crashlytics, error);
  },
  onSetUpError: (error) => {
    // Database failed to load -- offer the user to reload the app or log out
    fb.recordError(fb.crashlytics, error);
  },
  extraIncrementalIDBOptions: {
    onDidOverwrite: () => {
      // Called when this adapter is forced to overwrite contents of IndexedDB.
      // This happens if there's another open tab of the same app that's making changes.
      // Try to synchronize the app now, and if user is offline, alert them that if they close this
      // tab, some data may be lost
      // @TODO: implement
    },
    onversionchange: () => {
      // database was deleted in another browser tab (user logged out), so we must make sure we delete
      // it in this tab as well - usually best to just refresh the page
      /* @TODO:
      if (checkIfUserIsLoggedIn()) {
        window.location.reload();
      }
      */
    },
  },
});

// The rest is the same!
// Then, make a Watermelon database from it!
const db = new Database({
  adapter,
  modelClasses: [
    Footnote,
    Translation,
    VerseText,
  ],
});

export default db;
